import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from "react";
import type { Suggestion } from "../types";
import { useVirtualizedWaves } from "@/hooks/useVirtualizedWaves";
import { NftSuggestHiddenSelect } from "./NftSuggestHiddenSelect";
import { NftSuggestVirtualList } from "./NftSuggestVirtualList";
import { NftSuggestFooter } from "./NftSuggestFooter";
interface NftSuggestListProps {
  readonly items: Suggestion[];
  readonly activeIndex: number;
  readonly isOpen: boolean;
  readonly hiddenCount: number;
  readonly hideSpam: boolean;
  readonly onToggleSpam: () => void;
  readonly onHover: (index: number) => void;
  readonly onSelect: (item: Suggestion) => void;
}
const ROW_HEIGHT = 64;
const OVERSCAN = 6;
export function NftSuggestList(t0) {
  const $ = _c(20);
  const {
    items,
    activeIndex,
    isOpen,
    hiddenCount,
    hideSpam,
    onToggleSpam,
    onHover,
    onSelect
  } = t0;
  const scrollContainerRef = useRef(null);
  const listContainerRef = useRef(null);
  const virtualization = useVirtualizedWaves(items, "nft-picker-suggestions", scrollContainerRef, listContainerRef, ROW_HEIGHT, OVERSCAN, isOpen);
  let t1;
  let t2;
  if ($[0] !== activeIndex) {
    t1 = () => {
      if (activeIndex >= 0 && scrollContainerRef.current) {
        const container = scrollContainerRef.current;
        const itemTop = activeIndex * ROW_HEIGHT;
        const itemBottom = itemTop + ROW_HEIGHT;
        const containerTop = container.scrollTop;
        const containerBottom = containerTop + container.clientHeight;
        if (itemTop < containerTop) {
          container.scrollTop = itemTop;
        } else {
          if (itemBottom > containerBottom) {
            container.scrollTop = itemBottom - container.clientHeight;
          }
        }
      }
    };
    t2 = [activeIndex];
    $[0] = activeIndex;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  if ($[3] !== items || $[4] !== onSelect) {
    t3 = <NftSuggestHiddenSelect items={items} onSelect={onSelect} />;
    $[3] = items;
    $[4] = onSelect;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== activeIndex || $[7] !== items || $[8] !== onHover || $[9] !== onSelect || $[10] !== virtualization) {
    t4 = <NftSuggestVirtualList items={items} virtualization={virtualization} activeIndex={activeIndex} listContainerRef={listContainerRef} onHover={onHover} onSelect={onSelect} />;
    $[6] = activeIndex;
    $[7] = items;
    $[8] = onHover;
    $[9] = onSelect;
    $[10] = virtualization;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== hiddenCount || $[13] !== hideSpam || $[14] !== onToggleSpam) {
    t5 = hideSpam && <NftSuggestFooter hiddenCount={hiddenCount} onToggleSpam={onToggleSpam} />;
    $[12] = hiddenCount;
    $[13] = hideSpam;
    $[14] = onToggleSpam;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div ref={scrollContainerRef} className="tw-absolute tw-left-0 tw-right-0 tw-top-full tw-z-20 tw-mt-2 tw-max-h-80 tw-overflow-y-auto tw-rounded-xl tw-border tw-border-solid tw-border-iron-900 tw-bg-iron-950 tw-py-2 tw-shadow-2xl tw-ring-1 tw-ring-black/50 tw-scrollbar-thin tw-scrollbar-thumb-iron-700 tw-scrollbar-track-iron-900 desktop-hover:hover:tw-scrollbar-thumb-iron-600">{t3}{t4}{t5}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}